<template>
<div>
  <div class="d-flex" id="wrapper">
    <SideBar />
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-primary mb-0 hover-cursor" style="cursor: pointer;" @click="toPage('/rental/upgrade')">&nbsp;Upgrade - Downgrade Unit / </p>
          <p class="text-primary mb-0 hover-cursor">&nbsp;Edit Specification</p>

        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <h5 class="card-title mb-4">Edit Spesifikasi Awal</h5>
              <div class="col-lg-12 px-0">
                <div class="">
                  <div class="container">
                    <div class="row align-items-center mb-1">
                      <div class="col-lg-2 px-0">Perusahaan</div>
                      <div class="col-lg-10 px-0">
                        <multiselect :options="companies" v-model="companyCreate" label="companyName" placeholder="Pilih Perusahaan"></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row align-items-center mb-1">
                      <div class="col-lg-2 px-0">SN / Order Code</div>
                      <div class="col-lg-10 px-0">
                        <multiselect :options="catalogData" :loading="loadingCatalog" v-model="selectCatalog" placeholder="Serial Number / Order Code" label="snCode"></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    
                    <div class="row align-items-center my-2" v-if="selectTypeUpgrade == 'Sparepart'">
                      <div class="col-lg-2 px-0"></div>
                      <div class="col-lg-3 px-0"><button class="btn btn-primary radius-7" @click="addNewSparepart">Tambah Sparepart</button></div>
                      <div class="col-lg-7 text-danger" v-if="selectCatalog !== '' && selectCatalog.bomId == null">Item tidak Memiliki BOM.</div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row align-items-center mb-1" v-if="selectTypeUpgrade == 'Unit'">
                      <div class="col-lg-2 px-0">Catalog</div>
                      <div class="col-lg-10 px-0">
                        <div class="container">
                          <div class="row">
                            <div class="col-lg-4 px-0">
                              <multiselect :options="productNames" :loading="loadingCatalog" v-model="selectName" placeholder="Product Name" :optionsLimit="100" label="catalogName"></multiselect>
                            </div>
                            <div class="col-lg-4 pl-1 pr-0">
                              <multiselect :options="productVariants" :loading="loadingCatalog" v-model="selectVariant" placeholder="Product Variant" label="specification"></multiselect>
                            </div>
                            <div class="col-lg-4 pl-1 pr-0">
                              <multiselect :options="conditions" :loading="loadingCatalog" v-model="selectCondition" placeholder="Condition" label="conditionName"></multiselect>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="selectTypeUpgrade == 'Sparepart'">
                    <div class="row align-items-center mb-1 bg-grey radius-7" v-for="(item,i) in selectSparepartType" :key="`type-${i}`">
                      <button class="btn btn-sm btn-danger mt-2 mr-2 mb-2 ml-2 py-0 radius-7" v-if="i !== 0" @click="deleteSparepart(i)">x</button>
                      <div class="col-lg-12 pb-3" :class="i == 0 ? 'mt-5' : ''">
                        <div class="container pb-4">
                          <div class="row align-items-center">
                            <div class="my-3 col-lg-2 px-0">Sparepart {{i+1}}</div>
                              <div class="col-lg-10 px-0">
                                <!-- <multiselect :options="partTypes" v-model="selectSparepartType[i]" placeholder="Sparepart Type"></multiselect> -->
                                <select class="form-control" v-model="selectSparepartType[i]">
                                  <option value="" default>Select Type</option>
                                  <option value="RAM" :disabled="ramDisabled">RAM</option>
                                  <option value="Storage" :disabled="storageDisabled">Storage</option>
                                </select>
                              </div>
                          </div>
                        </div>
                        <div class="container">
                          <div class="row align-items-center">
                            <div class="col-lg-2 px-0">
                            </div>
                            <div class="col-lg-10 px-0 mb-4" v-if="selectSparepartType[i] == 'RAM'">
                              <div class="container" v-for="(itm,x) in ramSlot" :key="`ramSlot-${x}`">
                                <div class="row align-items-center">
                                  <div class="col-lg-5 pl-0">
                                    <select class="form-control upgrade-unit" v-model="ramSlot[x].index" disabled>
                                      <option value="" default>Sparepart Slot</option>
                                      <option v-for="(it,y) in ramSlot.length" :key="`ramSlotOpt-${y}`" :value="y+1" :selected="ramSlot[x].index == y+1">RAM KE - {{y+1}}</option>
                                    </select>
                                  </div>
                                  <div class="col-lg-5 pl-0">
                                    <multiselect :options="ramVariants" placeholder="Sparepart Variants" label="itemName" v-model="ramSlot[x].variant"></multiselect>
                                  </div>
                                  <div class="col-lg-2">
                                    <div class="row align-items-center justify-content-end">
                                      <button class="btn btn-danger radius-7 mx-2" style="width:60px" @click="deleteSlot('RAM', x)" v-if="x !== 0">-</button>
                                      <button class="btn btn-primary radius-7" style="width:60px" @click="addMoreSlot('RAM')" v-if="x == ramSlot.length -1" :disabled="ramSlot[x].variant == ''">+</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-10 px-0 mb-4" v-else-if="selectSparepartType[i] == 'Storage'">
                              <div class="container" v-for="(itm,x) in storageSlot" :key="`storageSlot-${x}`">
                                <div class="row align-items-center">
                                  <div class="col-lg-5 pl-0">
                                    <select class="form-control upgrade-unit" v-model="storageSlot[x].index" disabled>
                                      <option value="" default>Sparepart Slot</option>
                                      <option v-for="(it,y) in storageSlot.length" :key="`storageSlotOpt-${y}`" :value="y+1" :selected="storageSlot[x].index == y+1">STORAGE KE - {{y+1}}</option>
                                    </select>
                                  </div>
                                  <div class="col-lg-5 pl-0">
                                    <multiselect :options="storageVariants" placeholder="Sparepart Variants" label="itemName" v-model="storageSlot[x].variant"></multiselect>
                                  </div>
                                  <div class="col-lg-2">
                                    <div class="row align-items-center justify-content-end">
                                      <button class="btn btn-danger radius-7 mx-2" style="width:60px" @click="deleteSlot('Storage', x)" v-if="x !== 0">-</button>
                                      <button class="btn btn-primary radius-7" style="width:60px" @click="addMoreSlot('Storage')" v-if="x == storageSlot.length -1" :disabled="storageSlot[x].variant == ''">+</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row align-items-center mb-1">
                      <div class="col-lg-2 px-0">Harga</div>
                      <div class="col-lg-10 px-0">
                        <div class="container">
                          <div class="row">
                            <div class="col-lg-1 px-0">
                              <input type="text" class="form-control" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px;" value="Rp" disabled>
                            </div>
                            <div class="col-lg-11 px-0">
                              <input type="text" class="form-control" style="border-top-left-radius: 0px; border-bottom-left-radius: 0px;" name="price_value" placeholder="Harga" v-model="createPrice" @input="inputPrice(0)" @keypress="isNumber($event)">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row align-items-center justify-content-end mb-1 mt-4">
                      <button type="button" class="btn btn-danger mr-1" @click="$router.push('/rental/upgrade/detail/' + $route.params.id + '?companyId=' + $route.query.companyId)">Batal</button>
                      <button type="button" class="btn btn-primary" :disabled="!companyCreate || createPrice == '' || createLp == '' || createSn == '' || !selectCatalog" @click="submitEdit">Simpan</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
export default {
  name: 'EditSpecAwal',
  components: {
    SideBar,
    Multiselect
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      admin: '',
      adminId: '',
      viewOrder: false,
      editOrder: false,
      permission: '',
      companies: [],
      companyCreate: '',
      selectCatalog: '',
      catalogData: [],
      selectVariant: '',
      selectCondition: '',
      conditions: [],
      productVariants: [],
      productTypes: [{
        id: 1,
        typeName: 'Laptop'
      }, {
        id: 2,
        typeName: 'CPU'
      }],
      selectType: '',
      selectName: '',
      productNames: [],
      createSn: '',
      createLp: '',
      createPrice: '',
      addPrice: '',
      isLoading: false,
      upgradeTypes: ['Unit'],
      selectTypeUpgrade: 'Unit',
      selectSparepartType: [''],
      partTypes: ['RAM','Storage'],
      ramSlot: [{index: 1, variant: ''}],
      storageSlot: [{index: 1, variant: ''}],
      ramVariants: [],
      storageVariants: [],
      companyData: '',
      dataDetail: '',
      oldSpec: {
        id: '',
        name: '',
        processor: '',
        ram: '',
        storage: '',
        vga: ''
      },
      newSpec: {
        id: '',
        name: '',
        processor: '',
        ram: '',
        storage: '',
        vga: ''
      },
      detailName: '',
      productDetails: '',
      selectedType: [],
      ramDisabled: false,
      storageDisabled: false,
      loadingCatalog : false
    }
  },
  methods: {
    getDetailUpgrade() {
      this.$http.get(process.env.GET_EDIT_UPGRADE+ this.$route.params.id, 
      { 
        headers: {
          'Asani-Token': localStorage.getItem('jwt')
        } 
      })
      .then(res => {
        this.oldSpec = this.parseSpec(res.data.content.catalogId, res.data.content.catalogSpecifications)
        this.productDetails = res.data.content
        this.createPrice = this.tandaPemisahTitik(this.productDetails.price.toString())
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    checkIndex(i) {
      if (!this.selectedType.length) {
        this.selectedType.push(this.selectSparepartType[i])
        if (this.selectedType[i] == 'RAM') this.ramDisabled = true
        if (this.selectedType[i] == 'Storage') this.storageDisabled = true
      } else {
        if (this.selectedType[i] !== this.selectSparepartType[i]) {
          if (this.selectedType[i] == 'RAM') {
            this.ramSlot[i].variant = ''
            this.ramDisabled = false
          } else if (this.selectedType[i] == 'Storage') {
            this.storageSlot[i].variant = ''
            this.storageDisabled = false
          }
          this.selectedType[i] = this.selectSparepartType[i]
        }
      }

    },
    submitEdit() {
      let ram = []
      let storage = []
      let partpayload = {}
      if(this.selectTypeUpgrade == 'Sparepart') {
          this.ramSlot.forEach(el => {
            if(el !== '') {
              ram.push(el.variant)
            }
          })
          this.storageSlot.forEach(el => {
            if(el !== '') {
              storage.push(el.variant)
            }
          })
          if(ram.length > 0) {
            partpayload.RAM = ram
          }
          if(storage.length > 0) {
            partpayload.Storage = storage
          }
      }
      this.$http.post(process.env.UPDATE_SN, {
        upId: parseInt(this.$route.params.id),
        companyId: this.companyCreate.companyId,
        orderDetailsId: this.selectCatalog.odId,
        productId: this.selectVariant.catalogId,
        condition: this.selectCondition.conditionName,
        price: parseInt(this.createPrice.split('.').join('').replace(this.spaceRegex, ' ')),
      }, {
        headers: {
          'Asani-Token': localStorage.getItem('jwt')
        }
      })
      .then(res => {
        if(res.data.status == 200) {
          swal('Sukses', res.data.message, 'success')
          .then(() => {
            this.$router.push('/rental/upgrade/detail/'+this.$route.params.id + '?companyId=' + this.$route.query.companyId)
          })
        } else {
          swal('Error', res.data.message, 'error')
          if(res.data.status == 401) {
            this.handleLogout()
          }
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    addMoreSlot(type) {
      if(type == 'RAM') {
        this.ramSlot.push({index: this.ramSlot.length + 1,variant: ''})
      } else if(type == 'Storage') {
        this.storageSlot.push({index: this.storageSlot.length + 1,variant: ''})
      }
    },
    deleteSlot(type,id) {
      if(type == 'RAM') {
        let arr = []
        this.ramSlot.forEach((el,i) => {
          if(i !== id) {
            arr.push(el)
          } 
        })
        arr.forEach((el,i) => {
          el.index = i+1
        })
        this.ramSlot = arr
      } else if(type == 'Storage') {
        let arr = []
        this.storageSlot.forEach((el,i) => {
          if(i !== id) {
            arr.push(el)
          } 
        })
        this.storageSlot = arr
      }
    },
    addNewSparepart() {
      this.selectSparepartType.push('')
    },
    deleteSparepart(id) {
      let arr = []
      for (let x in this.selectSparepartType) {
        if (this.selectSparepartType[id] == 'RAM') {
          this.ramDisabled = false
          this.ramSlot = [{
            index: 1,
            variant: ''
          }]
        } else if (this.selectSparepartType[id] == 'Storage') {
          this.storageDisabled = false
          this.storageSlot = [{
            index: 1,
            variant: ''
          }]
        }
      }
      this.selectSparepartType.forEach((el, i) => {
        if (i !== id) {
          arr.push(el)
        }
      })
      this.selectedType[id] = ''
      this.selectSparepartType = arr
    },
    getSparepartRam() {
      
      this.$http.get(process.env.GET_SPAREPART_BOM + 'ram', {
        headers: {
          'Asani-Token': localStorage.getItem('jwt')
        }
      })
      .then(res => {
        if(res.data.status == 200) {
          let ramtype = ''
          let temp = ''
          if(this.selectCatalog.bomId) {
            this.selectCatalog.bomItem.forEach(el => {
              if(el.itemGroup == 'RAM') {
                temp = el.itemName.split(' ')
                for(let x in temp) {
                  if(temp[x].includes('DDR')) {
                    ramtype = temp[x]
                  }
                }
              }
            })
            let rams = []
            res.data.content.forEach(el => {
              if(el.itemName.includes(ramtype)) {
                rams.push(el)
              }
            })
            this.ramVariants = rams
          } else {
            this.ramVariants = res.data.content
          }
        } else{
          swal('Error', res.data.message, 'error')
          if(res.data.status == 401) {
            this.handleLogout()
          }
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    getSparepartStorage() {
      this.storageVariants = []
      this.$http.get(process.env.GET_SPAREPART_BOM + 'ssd', {
        headers: {
          'Asani-Token': localStorage.getItem('jwt')
        }
      })
      .then(res => {
        if(res.data.status == 200) {
          res.data.content.forEach(el => {
            this.storageVariants.push(el)
          })
          this.$http.get(process.env.GET_SPAREPART_BOM + 'hdd', {
            headers: {
              'Asani-Token': localStorage.getItem('jwt')
            }
          })
          .then(r => {
            if(r.data.status == 200) {
              r.data.content.forEach(ele => {
                this.storageVariants.push(ele)
              })
            } else {
              swal('Error', r.data.message, 'error')
              if(r.data.status == 401) {
              this.handleLogout()
              }
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
        } else{
          swal('Error', res.data.message, 'error')
          if(res.data.status == 401) {
            this.handleLogout()
          }
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    getCompanyList() {
      this.$http.get(process.env.GET_LESSEE_COMPANY, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          } else {
            this.companies = response.data.content
            this.getCompanyData()
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getCatalog(id) {
      this.loadingCatalog = true
      this.$http.get(process.env.CATALOG_UPGRADE + id, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt")
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.loadingCatalog = false
            this.catalogData = res.data.content
            this.catalogData.forEach(el => {
              if(el.odId == this.dataDetail.orderDetailsId) {
                this.selectCatalog = el
              }
            })
          } else if (res.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })

          } else {
            this.loadingCatalog = false
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }

        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getProductName() {
      this.$http
        .post(
          process.env.GET_CATALOG_NAME, {
            catalogType: this.selectCatalog.productType,
          }, {
            headers: {
              "Asani-Token": localStorage.getItem("jwt")
            },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });

          } else if (response.data.status == 200) {
            let tester = []
            tester.splice(0, 1, response.data.content)
            this.productNames = tester[0]
            this.productNames.forEach(el => {
              if(el.catalogName == this.productDetails.catalogName) {
                this.selectName = el
              }
            })
            // this.productNames = response.data.content
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    getVariant() {
      this.$http.post(process.env.GET_CATALOG_VARIAN, {
          catalogName: this.selectName.catalogName,
        }, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt")
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.productVariants = res.data.content
            this.productVariants.forEach(el => {
              if(el.catalogId == this.oldSpec.id) {
                this.selectVariant = el
              }
            })
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getCondition() {
      this.$http
        .post(
          process.env.GET_CATALOG_CONDITION, {
            catalogId: this.selectVariant.catalogId,
          }, {
            headers: {
              "Asani-Token": localStorage.getItem("jwt")
            },
          }
        )
        .then(res => {
          if (res.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });

          } else if (res.data.status == 200) {
            this.conditions = res.data.content.map(el=> {
              return {
                conditionName: el
              }
            })
            this.conditions.forEach(el => {
              if(el.conditionName == this.productDetails.newCondition) {
                this.selectCondition = el
              }
            })
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
        localStorage.removeItem('qc-cache')
      }
    },
    inputFormat(a) {
      return a.toLocaleString()
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    tandaPemisahTitik(b) {
      var _minus = false;
      if (b < 0) _minus = true;
      b = b.toString();
      b = b.replace(/\./g, "");
      b = b.replace("-", "");
      var c = "";
      var panjang = b.length;
      var j = 0;
      for (var i = panjang; i > 0; i--) {
        j = j + 1;
        if (j % 3 == 1 && j != 1) {
          c = b.substr(i - 1, 1) + "." + c;
        } else {
          c = b.substr(i - 1, 1) + c;
        }
      }
      let x = c.split('.').join('')
      if(+x > 100000000) {
        c = '99.999.999'
      }
      if (_minus) c = "-" + c;
      if(+x > 100000000) {
        c = '99.999.999'
      }
      return c;
    },
    inputPrice(index) {
      // this.createPrice.splice(index, 1, this.tandaPemisahTitik(this.createPrice))
      this.createPrice = this.tandaPemisahTitik(this.createPrice.toString())
    },
    getDetail() {
      this.$http.get(process.env.DETAIL_UPGRADE + this.$route.params.id, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt")
          }
        })
        .then(res => {
          if (res.data.status == 400) {

          } else if (res.data.status == 200) {
            this.dataDetail = res.data.content
            this.newSpec = this.parseSpec(res.data.content.newProductId, res.data.content.newProductSpec)
            this.orderStatus = res.data.content.status
            
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    parseSpec(id, data) {
      let arr = data.split('/')
      let arrn = arr[0].split(' ')
      let temp = arrn[arrn.length - 1]
      let arrname = []
      for (let i = 0; i < arrn.length - 1; i++) {
        arrname.push(arrn[i])
      }
      // let proc = temp[temp.length]
      let datas = {
        id: id,
        name: arrname.join(' '),
        processor: temp,
        ram: arr[1],
        storage: arr[2],
        vga: arr[3]
      }
      return datas
    },
    getCompanyData() {
      this.companies.forEach(el => {
        if(el.companyId == this.$route.query.companyId) {
          this.companyCreate = el
        }
      })
    },
    getDataEdit() {

    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('qc-cache')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    toPage(e) {
      this.$router.push(e)
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true
        }
        if (this.permission[i] == '3.1') {
          this.viewReturn = true
        }
        if (this.permission[i] == '3.2') {
          this.editReturn = true
        }
        if (this.permission[i] == '4.1') {
          this.viewProduct = true
        }
        if (this.permission[i] == '4.2') {
          this.editProduct = true
        }
        if (this.permission[i] == '5.1') {
          this.viewPairing = true
        }
        if (this.permission[i] == '5.2') {
          this.editPairing = true
        }
        if (this.permission[i] == '6') {
          this.viewReconcile = true
        }
        if (this.permission[i] == '7.1') {
          this.viewResolution = true
        }
        if (this.permission[i] == '7.2') {
          this.editResolution = true
        }
        if (this.permission[i] == '8.1') {
          this.viewLessor = true
        }
        if (this.permission[i] == '8.2') {
          this.editLessor = true
        }
        if (this.permission[i] == '9.1') {
          this.viewLessee = true
        }
        if (this.permission[i] == '9.2') {
          this.editLessee = true
        }
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewOrder == false) {
        this.$router.push('/')
      }
    }
  },
  watch: {
    companyCreate: function (val) {
      this.selectCatalog = ''
      this.selectType = ''
      if (val.companyId) {
        this.getCatalog(val.companyId)
      }
    },
    selectCatalog: function (val) {
      this.createSn = val.sn
      this.createLp = val.code
      this.selectName = ''
      this.productTypes.forEach(el => {
        if (el.id == val.productType) {
          this.selectType = el
        }
      })
  
      if(val){
        this.getProductName()
      }
      this.bomItem = val.bomItem
      this.ramSlot = [{index: 1, variant: ''}]
      this.storageSlot = [{index: 1, variant: ''}]
      if(this.selectTypeUpgrade == 'Sparepart') {
        this.getSparepartRam()
        this.getSparepartStorage()
      }
    },
    selectName: function (val) {
      this.selectVariant = ''
      if (val.catalogName) {
        this.getVariant()
      }
    },
    selectVariant: function (val) {
      this.selectCondition = ''
      if (val.catalogId) {
        this.getCondition()
      }
    },
    selectTypeUpgrade: function(val) {
      
      this.selectSparepartType = ['']
      
    },
    selectSparepartType: function (val) {
      this.getSparepartRam()
      this.getSparepartStorage()
      val.forEach((el, i) => {
        this.checkIndex(i)
        if (el == 'RAM') this.ramDisabled = true
        if (el == 'Storage') this.storageDisabled = true
      })
      // this.selectSparepartType = ['']
    },
  },
  created() {
    this.cekLogin()
    this.cekPermission()
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.getCompanyList()
    this.getDetail()
    this.getDetailUpgrade()
    this.getCompanyData()
    this.getDataEdit()
  }
}
</script>

<style>
.one-line-sm {
  display: flex;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.pagg {
  display: inline-flex;
  overflow: auto;
}

.total-data {
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}

.active {
  color: #2797FB;
}

.right-dropdown {
  margin-left: 7px;
}

.account-div {
  margin: 2px 2px;
}

.right-arrow {
  margin-left: auto;
}

.brand-logo {
  width: 120px;
}

.menu-title {
  margin-left: 1.125rem;
}

.menu-title-order {
  margin-left: 1.95rem;
}

.menu-title-payment {
  margin-left: 1.525rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}

li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}

li a.active {
  background-color: #4CAF50;
  color: white;
}

li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}

.redirect-link {
  text-decoration: underline #2797FB;
  cursor: pointer;
}

.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}

.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}

.nav-side-menu .toggle-btn {
  display: none;
}

.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}

.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}

.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}

.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}

.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}

.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}

.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}

.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }

  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }

  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}

@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}

@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.form-control-lg {
  display: block;
  width: 100%;
  min-height: 40px;
  font-size: .8rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control-lg {
    transition: none;
  }
}

.form-control-lg::-ms-expand {
  background-color: transparent;
  border: 0;
}

.form-control-lg:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control-lg::-webkit-input-placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control-lg::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control-lg:-ms-input-placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control-lg::-ms-input-placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control-lg::placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control-lg:disabled,
.form-control-lg[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

select.form-control-lg:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-lg-file,
.form-control-lg-range {
  display: block;
  width: 100%;
}

.radius-7{
  border-radius: 15px;
}

.bg-grey{
  background: #d6d6d662;
}

.upgrade-unit:disabled{
  background: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/EditSpecAwal.vue